import React from "react";
import { useTranslation } from "react-i18next";
import sunset from "../../Assets/sunset.webp"; // Imagen de fondo de las preguntas
import Contact from "../Home/Contact";
import ServiceInfo from "./ServiceInfo";
import { Helmet } from "react-helmet-async";
import Seoimg from "../../Assets/sobremi.webp";
import Aboutcard from "../About/AboutCard";
import { useLocation } from "react-router-dom";

const Sobremi = () => {
   const { t } = useTranslation();

   const location = useLocation();
   const selectedLanguage = location.pathname.startsWith("/en") ? "en" : "es";

   const seoTranslations = {
      es: {
         title: "Sobre Joan Company | Joan Company",
         description: "Ofrezco servicios profesionales de fotografía y vídeo aéreo con drones para inmobiliarias, eventos y proyectos técnicos.",
         keywords: "fotografía aérea, videografía aérea, servicios con drones, grabación con drones, filmación con drones, fotografía inmobiliaria con drones, eventos con drones, inspecciones técnicas con drones",
         canonical: "https://www.joancompany.es/sobre-mi",
      },
      en: {
         title: "About Joan Company | Joan Company",
         description: "I offer professional aerial photography and videography services with drones for real estate, events, and technical projects.",
         keywords: "aerial photography, aerial videography, drone services, drone recording, drone filming, real estate drone photography, events with drones, technical inspections with drones",
         canonical: "https://www.joancompany.es/en/sobre-mi",
      }
   };

   return (
      <div className="service-container">
         <Helmet>
            <title key="title">{seoTranslations[selectedLanguage].title}</title>
            <meta
               key="description"
               name="description"
               content={seoTranslations[selectedLanguage].description}
            />
            <meta
               key="keywords"
               name="keywords"
               content={seoTranslations[selectedLanguage].keywords}
            />
            <link rel="canonical" href={seoTranslations[selectedLanguage].canonical} />
            <meta property="og:image" content={Seoimg} />
            <meta property="og:title" content={seoTranslations[selectedLanguage].title} />
            <meta
               property="og:description"
               content={seoTranslations[selectedLanguage].description}
            />
            <link rel="image_src" href={Seoimg} />
            <link
               rel="alternate"
               href="https://www.joancompany.es/sobre-mi"
               hreflang="es"
            />
            <link
               rel="alternate"
               href="https://www.joancompany.es/en/sobre-mi"
               hreflang="en"
            />
            <html lang={selectedLanguage} />
         </Helmet>
         <ServiceInfo
            title={t("my_history")}
            image={sunset}
            subtitle={t("meet_me")}
            description={t("aerial_photography_desc")}
         />
         <Aboutcard />
         <Contact className="home-contact" />
      </div>
   );
};

export default Sobremi;
